import React from 'react';
import RingLoader from "react-spinners/RingLoader";
import './Loading.css';
function Loading() {
  return (
    <div className='container-loading'>
        <RingLoader color="rgb(30, 100, 210)" />
    </div>
  )
}

export default Loading